// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3L49L","content":"styles_content__2aAKd"};